import SwitchShopDialog from './SwitchShopDialog.vue';

export default SwitchShopDialog;
